export default __webpack_public_path__ + "static/media/mobile-money.a9536501.svg";